import * as loadingAction from "../../../../store/loading/action";
import * as messageAction from "../../../../store/message/action";

import { Card, CardBody, Col, Input, Row, Table } from "reactstrap";
import {
  GET_RP_BALANCE,
  GET_RP_BALANCE_EAST,
  GET_RP_BALANCE_EVENT,
  GET_RP_BALANCE_TOTAL,
  GET_RP_BALANCE_WEST
} from "../../../../helpers/url_api_constant";
import React, { useEffect, useState } from "react";

import ChartOffshore from "./ChartOffshore";
import ChartOnshore from "./ChartOnshore";
import PropTypes from "prop-types";
import moment from "moment";
import { post } from "helpers/api_helper";
import { useDispatch } from "react-redux";

function SectionBalancing(props) {
  // console.log(props.date)
  const dispatch = useDispatch();

  const [minMaxTotalList, setMinMaxTotalList] = useState([]);
  const [minMaxEastList, setMinMaxEastList] = useState([]);
  const [minMaxWestList, setMinMaxWestList] = useState([]);
  const [balancingOnshoreEast, setBalancingOnshoreEast] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,

  });
  const [balancingOnshoreWest, setBalancingOnshoreWest] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
  });
  const [balancingOnshoreTotal, setBalancingOnshoreTotal] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
    BALANCING_REMARK: ""
  });
  const [balancingOffshore, setBalancingOffshore] = useState({
    BALANCING_ENTRY: 0,
    BALANCING_ENTRY: 0,
    BALANCING_BALANCE: 0,
    OFFSHORE_REMARK: ""
  });
  const [balancingGraphData, setBalancingGraphData] = useState([]);
  const [balancingOffshoreGraphData, setBalancingOffshoreGraphData] = useState([]);

  const [dataCriteriaEast, setDataCriteriaEast] = useState(0);
  const [dataCriteriaWest, setDataCriteriaWest] = useState(0);
  const [dataCriteriaTotal, setDataCriteriaTotal] = useState(0);

  useEffect(
    function () {
      fetchData();
    },
    [props.summaryReportPid]
  );
  function numberFormat(number, digit = 2) {
    if (number === null || number === "null" || number === "") return "";
    function isFloat(n) {
      return Number(n) === n && n % 1 !== 0;
    }
    if (isFloat(number))
      return parseFloat(number.toFixed(digit)).toLocaleString(undefined, {
        minimumFractionDigits: digit,
      });
    return parseFloat(number).toLocaleString(undefined, {
      minimumFractionDigits: digit,
    });
  }
  const fetchData = async () => {
    function compare(a, b) {
      if (a.PRIORITY_FLAG < b.PRIORITY_FLAG) {
        return -1;
      }
      if (a.PRIORITY_FLAG > b.PRIORITY_FLAG) {
        return 1;
      }
      return 0;
    }
    dispatch(loadingAction.showLoading());
    try {
      let [res1, res2, res3, res4, minMaxTotal, minMaxEast, minMaxWest] = await Promise.all(
        [
          post(GET_RP_BALANCE, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
            BALANCECOLUMN_NAME: 'TSO'

          }),
          post(GET_RP_BALANCE, {
            REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
            BALANCECOLUMN_NAME: 'TSO'
          }),
          post(GET_RP_BALANCE_EVENT, {
            SUMMARYREPORT_PID:
              props.summaryReportPid || "f126e98a-3529-4a47-b497-4cba630d6682",
          }),
          post(GET_RP_BALANCE_EVENT, {
            REPORT_DATE: moment(props.date).format("YYYY-MM-DD"),
          }),
          post(GET_RP_BALANCE_TOTAL, {}),
          post(GET_RP_BALANCE_EAST, {}),
          post(GET_RP_BALANCE_WEST, {}),
        ]
      );

      setMinMaxTotalList(
        minMaxTotal.data.rpBalancingTotalList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      setMinMaxWestList(
        minMaxWest.data.rpBalancingWestList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );
      setMinMaxEastList(
        minMaxEast.data.rpBalancingEastList.map(row => ({
          max: row.BALANCE_MAX,
          min: row.BALANCE_MIN,
          startDate: moment(row.START_DATE).toDate(),
          endDate: row.END_DATE ? moment(row.END_DATE).toDate() : row.END_DATE,
        }))
      );

      let balancing = res1.data.rpBalancingList;
      let graphData = res2.data?.rpBalancingList;
      if (graphData) {
        setBalancingGraphData(graphData);
      } else {
        setBalancingGraphData([]);
      }

      let balancingEast = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "east"
      );
      let balancingWest = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "west"
      );
      let balancingTotal = balancing.find(
        item => item.BALANCING_ZONE.toLowerCase() == "total"
      );
      let balancingOffshore = res3.data.rpBalancingEventList

      // console.log(balancingEast)
      // console.log(balancingWest)
      // console.log(balancingTotal)

      let dataRangeCriteriaEast = minMaxEast.data.rpBalancingEastList.find(item => {
        // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
        // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
        if (moment(item.END_DATE).toDate() >= moment(props.date).toDate() && moment(item.START_DATE).toDate() <= moment(props.date).toDate()) {
          return true;
        } else if (moment(item.START_DATE).toDate() <= moment(props.date).toDate() && item.END_DATE == "" || item.END_DATE == null) {
          return true;
        }
        return false;
      });

      let dataRangeCriteriaWest = minMaxWest.data.rpBalancingWestList.find(item => {
        // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
        // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
        if (moment(item.END_DATE).toDate() >= moment(props.date).toDate() && moment(item.START_DATE).toDate() <= moment(props.date).toDate()) {
          return true;
        } else if (moment(item.START_DATE).toDate() <= moment(props.date).toDate() && item.END_DATE == "" || item.END_DATE == null) {
          return true;
        }
        return false;
      });

      let dataRangeCriteriaTotal = minMaxTotal.data.rpBalancingTotalList.find(item => {
        // console.log("start", moment(item.START_DATE).toDate(), "end", moment(item.END_DATE).toDate(), "fuel date", moment(data.FUEL_DATE).toDate());
        // console.log(moment(item.START_DATE).toDate() <= moment(data.FUEL_DATE).toDate() && item.END_DATE == null);
        if (moment(item.END_DATE).toDate() >= moment(props.date).toDate() && moment(item.START_DATE).toDate() <= moment(props.date).toDate()) {
          return true;
        } else if (moment(item.START_DATE).toDate() <= moment(props.date).toDate() && item.END_DATE == "" || item.END_DATE == null) {
          return true;
        }
        return false;
      });


      setDataCriteriaTotal( {min:dataRangeCriteriaTotal.BALANCE_MIN,max:dataRangeCriteriaTotal.BALANCE_MAX});
      // console.log(dataRangeCriteriaTotal.BALANCE_MAX);

      setDataCriteriaWest({min:dataRangeCriteriaWest.BALANCE_MIN,max:dataRangeCriteriaWest.BALANCE_MAX});
      // console.log(dataRangeCriteriaWest.BALANCE_MAX);

      setDataCriteriaEast({min:dataRangeCriteriaEast.BALANCE_MIN,max:dataRangeCriteriaEast.BALANCE_MAX});
      // console.log(dataRangeCriteriaEast.BALANCE_MAX);


      if (balancingOffshore.length > 0) {
        //   console.log(balancingOffshore[0])
        setBalancingOffshore(balancingOffshore[0])
      } else {
        setBalancingOffshore({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
          OFFSHORE_REMARK: ""
        })
      }
      if (res4.data?.rpBalancingEventList) {
        setBalancingOffshoreGraphData(res4.data.rpBalancingEventList)
      } else {
        setBalancingOffshoreGraphData([])
      }

      if (balancingEast) {
        setBalancingOnshoreEast(balancingEast);
      } else {
        setBalancingOnshoreEast({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
        });
      }
      if (balancingWest) {
        setBalancingOnshoreWest(balancingWest);
      } else {
        setBalancingOnshoreWest({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,

        });
      }
      if (balancingTotal) {
        setBalancingOnshoreTotal(balancingTotal);
      } else {
        setBalancingOnshoreTotal({
          BALANCING_ENTRY: 0,
          BALANCING_ENTRY: 0,
          BALANCING_BALANCE: 0,
          BALANCING_REMARK: ""
        });
      }
    } catch (error) {
      dispatch(messageAction.showMessage(error.message));
    }
    dispatch(loadingAction.hideLoading());
  };

  // useEffect(
  //   function () {
  //     console.log(minMaxTotalList);
  //     console.log(minMaxWestList);
  //     console.log(minMaxEastList);
  //   },
  //   [minMaxTotalList, minMaxWestList, minMaxEastList]
  // );

  return (
    <Row>

      <Row className="mt-0">
        <Col sm="6">
          <h5
            className="mb-0 sm-0"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Balancing
          </h5>
        </Col>
        <Col sm="6">
          <h5
            className="mb-0 sm-0 d-flex align-items-center justify-content-end"
            style={{ color: "#FFFFFF", fontWeight: "bold", fontSize: "1.1vw" }}
          >
            Gas Day : {moment(props.date).locale("en").format("DD MMM YYYY")}

          </h5>
        </Col>
      </Row>

      <Row className="mt-2">
        <hr />
      </Row>

      <div className="d-flex dashboard-content-body">


        <div className="d-flex" style={{ flex: 1, paddingRight: 2 }}>
          <div className="d-flex flex-column" style={{ flex: 1 }}>

            <div className="d-flex" style={{ flex: 1 }}>
              <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                <h5 className="ms-2" style={{ fontSize: "1.8vh", fontWeight: "bold" }}>Onshore Balancing East</h5>
                <Table
                  className="table table-bordered mb-0"
                >
                  <thead style={{ fontSize: "1.7vh", fontWeight: "bold" }}>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#5868b785",
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      ></th>
                      <th
                        style={{
                          backgroundColor: "#466597",// 667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Entry
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597",// 5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Exit
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597",// 667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Balancing
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold" }}
                  >
                    <tr>
                      <td>East</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreEast.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(
                          balancingOnshoreEast.BALANCING_EXIT / 1000
                          , 0)}
                      </td>
                      <td style={{ color:(balancingOnshoreEast.BALANCING_BALANCE > dataCriteriaEast.max||balancingOnshoreEast.BALANCING_BALANCE<dataCriteriaEast.min)? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(
                          balancingOnshoreEast.BALANCING_BALANCE
                          , 1)}
                        %
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div className="mt-0" style={{ width: '100%', position: 'relative', height: "65%", margin: 'auto' }}>
                  <ChartOnshore
                    balancingGraphData={balancingGraphData.filter(
                      item => item.BALANCING_ZONE.toLowerCase() == "east"
                    )}
                    minMax={minMaxEastList}
                    date={props.date}
                    summaryReportPid={props.summaryReportPid}
                    color={"#FFF35E"}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex" style={{ flex: 1 }}>
              <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                <h5 style={{ fontWeight: "bold", fontSize: "1.8vh" }}>Onshore Balancing</h5>
                <Table
                  className="table table-bordered mb-0"
                // style={{ height: "100%" }}
                >
                  <thead style={{ fontSize: "1.7vh", fontWeight: "bold", }}>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#5868b785", //
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      ></th>
                      <th
                        style={{
                          backgroundColor: "#466597",  //  667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Entry
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597", //5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Exit
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597", //667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Balancing
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold", }}
                  >
                    <tr>
                      <td>Total</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_EXIT / 1000
                          , 0)}
                      </td>

                      <td style={{ color:(balancingOnshoreTotal.BALANCING_BALANCE > dataCriteriaTotal.max||balancingOnshoreTotal.BALANCING_BALANCE<dataCriteriaTotal.min)  ? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(
                          balancingOnshoreTotal.BALANCING_BALANCE
                          , 1)}
                        %
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div className="mt-0" style={{ width: '100%', position: 'relative', height: "65%", margin: 'auto' }}>
                  <ChartOnshore
                    balancingGraphData={balancingGraphData.filter(
                      item => item.BALANCING_ZONE.toLowerCase() == "total"
                    )}
                    minMax={minMaxTotalList}
                    date={props.date}
                    summaryReportPid={props.summaryReportPid}
                    color={"#B2FF90"}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex" style={{ flex: 0.1 }}>
              <div className="d-flex flex-column align-items-center" style={{ width: "100%", position: 'relative' }}>
                <Input
                  readOnly
                  type="textarea"
                  rows="2"
                  style={{
                    border: "solid 1px #FFFFFF",
                    color: "#FFFFFF",
                    resize: "none",
                    width: "97%",
                  }}
                  className="form-control"

                  value={balancingOnshoreTotal.BALANCING_REMARK}
                />
              </div>
            </div>

          </div>
        </div>


        <div className="d-flex" style={{ flex: 1, borderLeft: "solid 2px #4A5576", paddingLeft: 2 }}>
          <div className="d-flex flex-column" style={{ flex: 1 }}>

            <div className="d-flex" style={{ flex: 1 }}>
              <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                <h5 style={{ fontWeight: "bold", fontSize: "1.8vh" }}>Onshore Balancing West</h5>
                <Table className="table table-bordered mb-0">
                  <thead style={{ fontSize: "1.7vh", fontWeight: "bold" }}>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#5868b785",//5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      ></th>
                      <th
                        style={{
                          backgroundColor: "#466597",//667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Entry
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597",//5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Exit
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597",//667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Balancing
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold", }}
                  >
                    <tr>
                      <td>West</td>
                      <td>
                        {numberFormat(
                          balancingOnshoreWest.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(
                          balancingOnshoreWest.BALANCING_EXIT / 1000
                          , 0)}
                      </td>

                      <td style={{ color:(balancingOnshoreWest.BALANCING_BALANCE > dataCriteriaWest.max||balancingOnshoreWest.BALANCING_BALANCE<dataCriteriaWest.min)? "#FF4545" : "#FFFFFF", fontWeight: "bold" }}>
                        {numberFormat(
                          balancingOnshoreWest.BALANCING_BALANCE
                          , 1)}
                        %
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div className="mt-0" style={{ width: '100%', position: 'relative', height: "65%", margin: 'auto' }}>
                  <ChartOnshore
                    balancingGraphData={balancingGraphData.filter(
                      item => item.BALANCING_ZONE.toLowerCase() == "west"
                    )}
                    minMax={minMaxWestList}
                    date={props.date}
                    summaryReportPid={props.summaryReportPid}
                    color={"#90EEFF"}
                  />
                </div>
              </div>
            </div>

            <div className="d-flex" style={{ flex: 1 }}>
              <div className="d-flex flex-column" style={{ flex: 1, position: 'relative' }}>
                <h5 className="ms-2" style={{ fontSize: "1.8vh", fontWeight: "bold", }}>Offshore Balancing</h5>
                <Table className="table table-bordered mb-0">
                  <thead style={{ fontSize: "1.7vh", fontWeight: "bold", }}>
                    <tr>
                      <th
                        style={{
                          backgroundColor: "#5868b785", //
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      ></th>
                      <th
                        style={{
                          backgroundColor: "#466597", // 667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Entry
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597",// 5868b785
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Exit
                      </th>
                      <th
                        style={{
                          backgroundColor: "#466597",// 667eef85
                          color: "#FEF6AA",
                          textAlign: "center",
                          width: "20%",
                        }}
                      >
                        Balancing
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    style={{ color: "#FFFFFF", textAlign: "center", fontSize: "1.7vh", fontWeight: "bold", }}
                  >
                    <tr>
                      <td>Total</td>
                      <td>
                        {numberFormat(
                          balancingOffshore.BALANCING_ENTRY / 1000
                          , 0)}
                      </td>
                      <td>
                        {numberFormat(
                          balancingOffshore.BALANCING_EXIT / 1000
                          , 0)}
                      </td>

                      <td style={{ fontWeight: "bold" }}>
                        {numberFormat(
                          balancingOffshore.BALANCING_BALANCE
                          , 1)}
                        %
                      </td>
                    </tr>
                  </tbody>
                </Table>
                <div className="mt-0" style={{ width: '100%', position: 'relative', height: "65%", margin: 'auto' }}>
                  <ChartOffshore
                    balancingGraphData={balancingOffshoreGraphData}
                    date={props.date}
                    summaryReportPid={props.summaryReportPid}

                  />
                </div>
              </div>
            </div>

            <div className="d-flex" style={{ flex: 0.1 }}>
              <div className="d-flex flex-column align-items-center" style={{ width: "100%", position: 'relative' }}>
                <Input
                  readOnly
                  type="textarea"
                  rows="2"
                  style={{
                    border: "solid 1px #FFFFFF",
                    color: "#FFFFFF",
                    resize: "none",
                    width: "97%",
                  }}
                  className="form-control"
                  value={balancingOffshore.OFFSHORE_REMARK}
                />
              </div>
            </div>

          </div>
        </div>


      </div>



      {/* <Row className="mt-0">
        <Col sm="6" style={{ borderRight: "2px solid #4A5576" }}>
          <Row>
            <h5>Onshore Balancing</h5>
            <div
              className="table-responsive mt-0"
              style={{ height: "100%" }}
            >
              <Table
                className="table table-bordered mb-0"
                style={{ height: "100%" }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    ></th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Entry
                    </th>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Exit
                    </th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Balancing
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{ color: "#FFFFFF", textAlign: "center" }}
                >
                  <tr>
                    <td>Total</td>
                    <td>
                      {numberFormat(
                        balancingOnshoreTotal.BALANCING_ENTRY / 1000
                      )}
                    </td>
                    <td>
                      {numberFormat(
                        balancingOnshoreTotal.BALANCING_EXIT / 1000
                      )}
                    </td>

                    <td style={{ color: balancingOnshoreTotal.BALANCING_BALANCE > dataCriteriaTotal ? "#F01406" : "#FFFFFF" }}>
                      {numberFormat(
                        balancingOnshoreTotal.BALANCING_BALANCE
                      )}
                      %
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
          <Row className="mt-0">
            <ChartOnshore
              balancingGraphData={balancingGraphData.filter(
                item => item.BALANCING_ZONE.toLowerCase() == "total"
              )}
              minMax={minMaxTotalList}
              date={props.date}
              summaryReportPid={props.summaryReportPid}
            />
          </Row>
          <Row className="mt-0">
            <Col sm="12">
              <Input
                readOnly
                type="textarea"
                rows="2"
                style={{
                  border: "solid 1px #FFFFFF",
                  color: "#FFFFFF",
                }}
                className="form-control"

                value={balancingOnshoreTotal.BALANCING_REMARK}
              />
            </Col>
          </Row>
        </Col>



        <Col sm="6">
          <Row>
            <h5>Offshore Balancing</h5>
            <div className="table-responsive mt-0">
              hover-table-highlight
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    ></th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Entry
                    </th>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Exit
                    </th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Balancing
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{ color: "#FFFFFF", textAlign: "center" }}
                >
                  <tr>
                    <td>Total</td>
                    <td>
                      {numberFormat(
                        balancingOffshore.BALANCING_ENTRY / 1000
                      )}
                    </td>
                    <td>
                      {numberFormat(
                        balancingOffshore.BALANCING_EXIT / 1000
                      )}
                    </td>

                    <td>
                      style={{ color: "#F01406" }}
                      {numberFormat(
                        balancingOffshore.BALANCING_BALANCE
                      )}
                      %
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
          <Row className="mt-0">
            <ChartOffshore
              balancingGraphData={balancingOffshoreGraphData}
              date={props.date}
              summaryReportPid={props.summaryReportPid}
            />
          </Row>
          <Row className="mt-0">
            <Col sm="12">
              <Input
                readOnly
                type="textarea"
                rows="2"
                style={{
                  border: "solid 1px #FFFFFF",
                  color: "#FFFFFF",
                }}
                className="form-control"
                value={balancingOffshore.OFFSHORE_REMARK}
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row className="mt-2">
        <hr />
      </Row>

      <Row className="mt-0">
        <Col sm="6" style={{ borderRight: "2px solid #4A5576" }}>
          <Row>
            <h5>Onshore Balancing West</h5>
            <div className="table-responsive mt-0">
              hover-table-highlight
              <Table className="table table-bordered mb-0">
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    ></th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Entry
                    </th>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Exit
                    </th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Balancing
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{ color: "#FFFFFF", textAlign: "center" }}
                >
                  <tr>
                    <td>West</td>
                    <td>
                      {numberFormat(
                        balancingOnshoreWest.BALANCING_ENTRY / 1000
                      )}
                    </td>
                    <td>
                      {numberFormat(
                        balancingOnshoreWest.BALANCING_EXIT / 1000
                      )}
                    </td>

                    <td style={{ color: balancingOnshoreWest.BALANCING_BALANCE > dataCriteriaWest ? "#F01406" : "#FFFFFF" }}>
                      {numberFormat(
                        balancingOnshoreWest.BALANCING_BALANCE
                      )}{" "}
                      %
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
          <Row className="mt-0">
            <ChartOnshore
              balancingGraphData={balancingGraphData.filter(
                item => item.BALANCING_ZONE.toLowerCase() == "west"
              )}
              minMax={minMaxWestList}
              date={props.date}
              summaryReportPid={props.summaryReportPid}
            />
          </Row>
          <Row className="mt-0"></Row>
        </Col>

        <Col sm="6">
          <Row>
            <h5>Onshore Balancing East</h5>
            <div
              className="table-responsive mt-0"
              style={{ height: "100%" }}
            >
              <Table
                className="table table-bordered mb-0"
                style={{ height: "100%" }}
              >
                <thead>
                  <tr>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    ></th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Entry
                    </th>
                    <th
                      style={{
                        backgroundColor: "#5868b785",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Exit
                    </th>
                    <th
                      style={{
                        backgroundColor: "#667eef85",
                        color: "#3AD5FF",
                        textAlign: "center",
                        width: "20%",
                      }}
                    >
                      Balancing
                    </th>
                  </tr>
                </thead>
                <tbody
                  style={{ color: "#FFFFFF", textAlign: "center" }}
                >
                  <tr>
                    <td>East</td>
                    <td>
                      {numberFormat(
                        balancingOnshoreEast.BALANCING_ENTRY / 1000
                      )}
                    </td>
                    <td>
                      {numberFormat(
                        balancingOnshoreEast.BALANCING_EXIT / 1000
                      )}
                    </td>
                    <td style={{ color: balancingOnshoreEast.BALANCING_BALANCE > dataCriteriaEast ? "#F01406" : "#FFFFFF" }}>
                      {numberFormat(
                        balancingOnshoreEast.BALANCING_BALANCE
                      )}
                      %
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Row>
          <Row className="mt-0">

            <ChartOnshore
              balancingGraphData={balancingGraphData.filter(
                item => item.BALANCING_ZONE.toLowerCase() == "east"
              )}
              minMax={minMaxEastList}
              date={props.date}
              summaryReportPid={props.summaryReportPid}
            />
          </Row>
          <Row className="mt-0"></Row>
        </Col>
      </Row> */}

    </Row >
  );
}

SectionBalancing.propTypes = {
  t: PropTypes.any,
  date: PropTypes.any,
  summaryReportPid: PropTypes.any,
};

export default SectionBalancing;
